import Commander from "../Commander";
import {EASE, getTween, getTweenAsync} from "../../framework/src/modules/Tween";
import {pixiSetTimeout, pixiSetTimeoutAsync} from "../../framework/src/engine/pixi/pixiTimeout";
import * as PIXI from "pixi.js-legacy";
import {numberFormat} from "../../framework/src/helpers";

export default class Counter {

    constructor(layers, wallet, BigWin, audio) {
        this.layers = layers;
        this.wallet = wallet;
        this.BigWin = BigWin;
        this.audio = audio;

        // 5 times length of One symbol animation
        this.duration = 5 * .065; // has to be same as SymbolAnimations:49
        this.endPause = .5;

        this.isSkip = false;
        this.isShown = false;

        this.tween = {n: 0};
    }

    init(filter) {
        this.filter = filter;

        this.container = new PIXI.Container();
        this.container.position.set(640,-190);
        // this.container.scale.set(0,0);

        this.bg = Commander.getSprite("winFactor_table.png", 0,70);
        this.bg.filters = [this.BigWin.filters.lightmap, this.BigWin.filters.colorMatrix2];

        this.number = new PIXI.BitmapText("0",{
            fontName: "font_win-export",
            fontSize: 80,
            tint: 0xFFFFFF,
            align: 'center',
            letterSpacing: 0,
            maxWidth: 1280
        });
        this.number.position.set(0, 115);
        this.number.anchor.set(.5,.5);
        this.number.filters = [this.filter];

        this.container.addChild(this.bg, this.number);
        this.layers.counter.addChild(this.container);
    }

    async run(win, len) {
        if (win > 0) {
            let time = len * this.duration;
            this.show(time);
            this.BigWin.setDecimalPlaces(win)
            await this.count(win, time);
        }
    }

    async show() {
        if (!this.isShown) {
            this.isShown = true;
            await this.hideLogo();
            await getTweenAsync(this.container, {y: -100}, 100, EASE.QUAD_I);
        }
    }

    async count(win, time) {
        let oldWin = this.wallet.getWin();
        this.tween.n = this.wallet.moneyToCredit(oldWin);
        this.audio.playTrack("win_Counter_Start");
        await getTweenAsync(this.tween, {n: this.wallet.moneyToCredit(oldWin + win)}, time*1000, EASE.LINEAR,() => {
            this.number.text =numberFormat(
                    this.tween.n,
                    this.BigWin.counterDecimalPlaces,
                    '.',
                    ' '
                )
            if (this.isSkip) {
                Commander.removeTween(this.tween);
                this.number.text = numberFormat(
                    this.wallet.moneyToCredit(oldWin + win),
                    this.BigWin.counterDecimalPlaces,
                    '.',
                    ' '
                )
            }
        });
        await pixiSetTimeoutAsync(this.endPause);
    }

    async hide() {
        if (this.isShown) {
            pixiSetTimeout(.1, () => {
                this.audio.playTrack("win_Counter_Stop");
            });
            await getTweenAsync(this.container, {y: -260}, 250, EASE.QUAD_I);
            await this.showLogo();
            this.isShown = this.isSkip = false;
            this.reset();
        }
    }

    skip() {
        this.isSkip = true;
    }

    async hideLogo() {
        let logo = this.getLogo();
        await getTweenAsync(logo, {y: -150}, 100, EASE.QUAD_I);
    }

    async showLogo() {
        let logo = this.getLogo();
        logo.gotoAndPlay(0);
        await getTweenAsync(logo, {y: 0}, 100, EASE.QUAD_I);
    }

    getLogo() {
        return this.layers.logo.children[0];
    }

    reset() {
        this.tween.n = 0;
    }
}